export const MIN_RESCHEDULE_TIME = 2;
export const LAST_START_TIME = 'last-time';
export const PROPOSED_DATE = 'proposed-date';

export enum AppointmentHasuraStatus {
  PendingProviderApproval = 1,
  PendingCapturePayment = 2,
  Booked = 3,
  NotPaidFailedAuthorization = 4,
  NotPaidFailedWithdrawal = 5,
  Canceled = 6,
  Completed = 7,
  PatientNotShowingUp = 8,
  ProviderNotShowingUp = 9,
  NobodyNotShowingUp = 10,
  PendingAuthorizedPayment = 11,
}
